<!--Filter Options-->
<div class="ItemBorder MainGrid2Col">
	<label>App:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="AppTypeID" [(ngModel)]="AppType">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstAppType" [ngValue]="o">{{ o.Desc }}</option>
	</select>

	<label>School:</label>
	<caass-schoolselector [ShowAll]="true" [Disabled]="IsLoading() == true" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText">
	</caass-schoolselector>

	<label *ngIf="StudentMode() == true">Grade Level:</label>
	<select *ngIf="StudentMode() == true" [disabled]="IsLoading() == true" class="form-control" name="GradeLevelID" [(ngModel)]="GradeLevelID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstGradeLevel" [ngValue]="o.GradeLevelID">{{ o.GradeLevelDesc }}</option>
	</select>

	<label *ngIf="StudentMode() == true">Academy:</label>
	<select *ngIf="StudentMode() == true" [disabled]="IsLoading() == true" class="form-control" name="AcademyID" [(ngModel)]="AcademyID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstAcademy" [ngValue]="o.AcademyID">{{ o.AcademyDesc }}</option>
	</select>

	<label *ngIf="StudentMode() == true">Homeroom:</label>
	<select *ngIf="StudentMode() == true" [disabled]="IsLoading() == true" class="form-control" name="HomeroomID" [(ngModel)]="HomeroomID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstHomeroom" [ngValue]="o.HomeroomID">{{ o.HomeroomDesc }}</option>
	</select>

	<label *ngIf="StudentMode() == true">Group:</label>
	<select *ngIf="StudentMode() == true" [disabled]="IsLoading() == true" class="form-control" name="GroupID" [(ngModel)]="GroupID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstGroup" [ngValue]="o.GroupID">{{ o.GroupName }}</option>
	</select>

	<label *ngIf="StaffMode() == true">Staff Type:</label>
	<select *ngIf="StaffMode() == true" [disabled]="IsLoading() == true" class="form-control" name="PersonTypeID" [(ngModel)]="PersonTypeID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstPersonType" [ngValue]="o.PersonTypeID">{{ o.PersonTypeDesc }}</option>
	</select>

	<label *ngIf="StaffMode() == true">Email:</label>
	<select *ngIf="StaffMode() == true" [disabled]="IsLoading() == true" class="form-control" name="HasEmail" [(ngModel)]="HasEmail">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstHasEmail" [ngValue]="o.ID">{{ o.Desc }}</option>
	</select>

	<label>Active:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="Active" [(ngModel)]="Active">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstActive" [ngValue]="o.ID">{{ o.Desc }}</option>
	</select>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-success" (click)="onExport()">Export</button>
	<button [disabled]="Processing == true" class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>
